import React from 'react';
import './Til.css';
import Section from '../common/Section';

export default function Til() {
  return (
    <Section title="[ TIL ]" link="/til" contentClassName="til-content">
    </Section>
  );
}
